// Howard University's undergraduate majors (#2748). Read on 2026-10-01
// from the Office of Admission's "Undergraduate Academic Programs" page
// (admission.howard.edu/undergraduate/academic-programs), section
// "Undergraduate Programs - Majors & Concentrations", which lists each
// school's majors with the indented concentrations beneath them. Howard's
// online catalog (catalog.howard.edu) did not resolve. Kept: every major
// line; concentrations are folded into the major's note; "Undecided (No
// degree awarded)", the unlabeled Health Education Management and
// Pre-Dental / Pre-Medicine lines and a repeated Computer Information
// Systems line are left out, and the page's separate minors list too.
// Computer Information Systems (BBA-IS) is kept as a major because it
// carries its own BBA code although the page indents it. `degree` is the
// program code exactly as the page prints it (BA-AFRS, BBA-ACCT,
// BSCHE-CHEG, B-MUSC ...), whose first part names the degree; Sports
// Management, Communication Studies and the joint degrees carry no code,
// so `degree` is null there. The joint/dual degree names are the page's
// own, with its dash dropped. The KB's majors list was the starting point;
// the page wins.
const majors = {
    "slug": "howard-university",
    "read": "2026-10-01",
    "intro": "Every undergraduate major Howard's Office of Admission lists, grouped by the school or college that offers it, with Howard's program code, which begins with the degree. Concentrations are noted under each major; minors are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "Howard University Admission, Undergraduate Academic Programs",
                "url": "https://admission.howard.edu/undergraduate/academic-programs"
            },
            "majors": [
                {
                    "name": "African Studies",
                    "degree": "BA-AFRS"
                },
                {
                    "name": "Afro-American Studies",
                    "degree": "BA-AFAM"
                },
                {
                    "name": "Biology",
                    "degree": "BS-BIOL"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS-CHEM"
                },
                {
                    "name": "Criminology",
                    "degree": "BA-CRIM"
                },
                {
                    "name": "Economics",
                    "degree": "BA-ECON"
                },
                {
                    "name": "English",
                    "degree": "BA-ENGL",
                    "note": "Concentration: Creative Writing."
                },
                {
                    "name": "Health Education",
                    "degree": "BS-HLED",
                    "note": "Concentrations: Community Health; Maternal and Child Health."
                },
                {
                    "name": "History",
                    "degree": "BA-HIST"
                },
                {
                    "name": "Human Performance",
                    "degree": "BS-HHPL",
                    "note": "Concentration: Sports Medicine."
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BA/BS-INTS",
                    "note": "Areas: Bioethics, Community Development, Environmental Science, Environmental Studies, Humanities: Ancient & Modern, International Affairs."
                },
                {
                    "name": "Mathematics",
                    "degree": "BS-MATH",
                    "note": "Concentrations: Actuarial Science, Applied Mathematics, Math Education, Pure Mathematics."
                },
                {
                    "name": "Philosophy",
                    "degree": "BA-PHIL"
                },
                {
                    "name": "Physics",
                    "degree": "BS-PHYS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA-POLS"
                },
                {
                    "name": "Psychology",
                    "degree": "BS-PSYC"
                },
                {
                    "name": "Sociology",
                    "degree": "BA-SOCI"
                },
                {
                    "name": "Spanish",
                    "degree": "BA-SPAN"
                },
                {
                    "name": "Sports Management",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Fine Arts",
            "source": {
                "label": "Howard University Admission, Undergraduate Academic Programs",
                "url": "https://admission.howard.edu/undergraduate/academic-programs"
            },
            "majors": [
                {
                    "name": "Art",
                    "degree": "BFA-Art",
                    "note": "Concentrations: Ceramics, Electronic Studio Art, Fashion Design, Graphic Design, Interior Design, Painting, Photography."
                },
                {
                    "name": "Music",
                    "degree": "B-MUSC"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "BFA-THEA",
                    "note": "Concentrations: Acting, Dance, Musical Theatre, Theatre Arts Administration, Theatre Technology."
                }
            ]
        },
        {
            "name": "School of Business",
            "source": {
                "label": "Howard University Admission, Undergraduate Academic Programs",
                "url": "https://admission.howard.edu/undergraduate/academic-programs"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BBA-ACCT"
                },
                {
                    "name": "Computer Information Systems",
                    "degree": "BBA-IS"
                },
                {
                    "name": "Finance",
                    "degree": "BBA-FINC",
                    "note": "Concentrations: Actuarial Science; Risk Management."
                },
                {
                    "name": "International Business",
                    "degree": "BBA-IB"
                },
                {
                    "name": "Management",
                    "degree": "BBA-MGMT",
                    "note": "Concentration: Entrepreneurship."
                },
                {
                    "name": "Marketing",
                    "degree": "BBA-MKTG"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "BBA-SCMT"
                }
            ]
        },
        {
            "name": "School of Education",
            "source": {
                "label": "Howard University Admission, Undergraduate Academic Programs",
                "url": "https://admission.howard.edu/undergraduate/academic-programs"
            },
            "majors": [
                {
                    "name": "Human Development",
                    "degree": "BS-HUMD"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BS-ELEM"
                }
            ]
        },
        {
            "name": "College of Engineering & Architecture",
            "source": {
                "label": "Howard University Admission, Undergraduate Academic Programs",
                "url": "https://admission.howard.edu/undergraduate/academic-programs"
            },
            "majors": [
                {
                    "name": "Architecture & Design Studies",
                    "degree": "BS-ARCHDS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BSCHE-CHEG"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BSCIV-CIVL"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BSCOEG"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BSEEE-ELEC"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BSMECH"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS-COSI"
                }
            ]
        },
        {
            "name": "College of Nursing and Allied Health Sciences",
            "source": {
                "label": "Howard University Admission, Undergraduate Academic Programs",
                "url": "https://admission.howard.edu/undergraduate/academic-programs"
            },
            "majors": [
                {
                    "name": "Clinical Laboratory Science",
                    "degree": "BSCLS-CLAB"
                },
                {
                    "name": "Health Management",
                    "degree": "BS-HSCI",
                    "note": "The page lists it as \"(HLMN major)\"."
                },
                {
                    "name": "Health Sciences",
                    "degree": "BS-HSCI"
                },
                {
                    "name": "Nursing",
                    "degree": "BS-NURS"
                },
                {
                    "name": "Nutritional Sciences",
                    "degree": "BS-NUTR"
                },
                {
                    "name": "Radiation Therapy",
                    "degree": "BS-RADT"
                }
            ]
        },
        {
            "name": "School of Communications",
            "source": {
                "label": "Howard University Admission, Undergraduate Academic Programs",
                "url": "https://admission.howard.edu/undergraduate/academic-programs"
            },
            "majors": [
                {
                    "name": "Media, Journalism, & Film",
                    "degree": "BA-MJFC",
                    "note": "Concentrations: Audio Production, Interdisciplinary Comm. Studies, Journalism, Television & Film Production."
                },
                {
                    "name": "Communication Studies",
                    "degree": null,
                    "note": "Concentrations: Advertising and Public Relations, Legal Communication, Management and Organizational Communications."
                }
            ]
        },
        {
            "name": "Joint and dual degree programs",
            "source": {
                "label": "Howard University Admission, Undergraduate Academic Programs",
                "url": "https://admission.howard.edu/undergraduate/academic-programs"
            },
            "majors": [
                {
                    "name": "BS/MD",
                    "degree": null,
                    "note": "College of Arts and Sciences and the College of Medicine."
                },
                {
                    "name": "BS/DDS",
                    "degree": null,
                    "note": "College of Arts and Sciences and the College of Dentistry."
                },
                {
                    "name": "BA/JD",
                    "degree": null,
                    "note": "College of Arts and Sciences or the School of Communications, with the School of Law."
                },
                {
                    "name": "BS Human Development/MSW",
                    "degree": null,
                    "note": "School of Education and the School of Social Work."
                }
            ]
        }
    ]
};

export default majors;
